'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const gt=require('../../../dist-es6/client/utilities/groupTreeExtensions');
const strEx=require('pulsar-utils/dist-es6/extensions/stringExtensions');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const Group=require('../../../dist-es6/shared/domain/group');

const DisplaySettingsService=require('../../../dist-es6/client/services/displaySettingsService');let

GroupTreeService=class GroupTreeService extends BaseService{
constructor(displaySettingsService){
_.ensureInstanceOf(DisplaySettingsService,displaySettingsService);

super();

this._displaySettingsService=displaySettingsService;

this.reset();
}

reset(){
this._groupTree=null;
this._groupsById=null;
this._selectedGroup=null;
this._selectedGroupParents=[];
this._currentlyLoadedGroupIds=new Set;
this._pendingSelectionId=null;
this._expandedGroups=null;
this._hideAllGroupsByDefault=!1;
this.isUserRestrictedFromSeeingAllGroups=!1;
this.sidebarVisibilitySettings={
organizationGroupName:'Organization',
hideOrganizationInSidebar:!1};

}

expandAllGroups(){
this.expandedGroups=_.values(this._groupsById).filter(g=>_.exists(g.id)&&g.children.length!==0);
}

collapseAllGroups(){
this.expandedGroups=[];
}

get groupTree(){
return this._groupTree;
}

get expandedGroups(){
return this._expandedGroups;
}

set expandedGroups(expandedGroups){
this._expandedGroups=expandedGroups;
if(!_.exists(this._expandedGroups)){
return;
}
this._displaySettingsService.stickySettings.set('expandedSidebarGroups',new Set(this._expandedGroups.map(g=>g.id)));
}

set groupTree(groupTree){
_.ensureArrayOf(Object,groupTree);
if(groupTree.length===0||groupTree[0].id!==null){
throw new Error(`Expecting at least 'Organization' group`);
}

this.isUserRestrictedFromSeeingAllGroups=!1;
if(_.exists(this._displaySettingsService,'groupVisibilitySettings.visibleGroupIds')){
const visibleGroupIds=new Set(this._displaySettingsService.groupVisibilitySettings.visibleGroupIds);

if(visibleGroupIds.size===0){
groupTree=[];
this.isUserRestrictedFromSeeingAllGroups=!0;
}else{
const visibleGroups=groupTree.filter(g=>visibleGroupIds.has(g.id));
const originalOrgGroup=groupTree.find(g=>g.isSpecialGroupContainingWholeOrg);
const visiblePersonIds=new Set(visibleGroups.flatMap(g=>g.aggregatePersons.map(p=>p.id)));

originalOrgGroup.removePersonsNotMatching(p=>visiblePersonIds.has(p.id));
}
}else if(this._hideAllGroupsByDefault){
groupTree=[];
this.isUserRestrictedFromSeeingAllGroups=!0;
}

this._groupTree=groupTree;
this._currentlyLoadedGroupIds=new Set(this._groupTree.map(g=>g.id));
this._parentGroupMap=_getGroupParentMap(this._groupTree);

const flattenedGroupsTree=[...treeUtils.flatten(groupTree)];
this._groupsById=_(flattenedGroupsTree).keyBy(group=>group.id).value();

const stickyExpandedGroups=this._displaySettingsService.stickySettings.get('expandedSidebarGroups');
if(!_.exists(stickyExpandedGroups)){
this.expandedGroups=flattenedGroupsTree.filter(g=>g.children.length!==0);
}else{

this._expandedGroups=flattenedGroupsTree.filter(g=>stickyExpandedGroups.has(g.id));
}

this._checkAndUpdateOrgVisibilityInSidebarIfNeeded();

if(_.exists(this._pendingSelectionId)){
this.selectGroupWithId(this._pendingSelectionId);
this._pendingSelectionId=null;
return;
}

this.selectGroupWithId(this._displaySettingsService.stickySettings.get('selectedGroupId'));
}

get selectedGroup(){
return this._selectedGroup;
}

get selectedGroupParents(){
return this._selectedGroupParents;
}

selectGroupWithId(id,{forceExpansion=!1}={}){
if(!_.exists(this._groupsById)){
this._pendingSelectionId=id;
return;
}

let lastSelectedGroupId=_.get(this._selectedGroup,'id');

const fallbackGroup=this.sidebarVisibilitySettings.hideOrganizationInSidebar?
this._groupTree.find(g=>g.id!==null):
this._groupsById[null];

if(id===null&&this.sidebarVisibilitySettings.hideOrganizationInSidebar&&_.exists(fallbackGroup)){
id=fallbackGroup.id;
}

this._selectedGroup=this._groupsById[id]||this._groupsById[_.get(fallbackGroup,'id',null)];
if(!this._selectedGroup){
return;
}

this._selectedGroupParents=_getParentGroupsOf(this._selectedGroup,this._parentGroupMap);
this._displaySettingsService.stickySettings.set('selectedGroupId',this.selectedGroup.id);

if(!forceExpansion&&lastSelectedGroupId===id){
return;
}

const collapsedParentGroups=_.without(this._selectedGroupParents,...this._expandedGroups);
if(collapsedParentGroups.length===0){
return;
}

this.expandedGroups=_.concat(this._expandedGroups,collapsedParentGroups);
}

updateOrgLevelGroupVisibilitySettings({hideAllGroupsByDefault=!1}={}){
this._hideAllGroupsByDefault=hideAllGroupsByDefault;

this._checkAndUpdateOrgVisibilityInSidebarIfNeeded();
}

_checkAndUpdateOrgVisibilityInSidebarIfNeeded(){
const visibleGroupIds=_.get(this._displaySettingsService,'groupVisibilitySettings.visibleGroupIds');
const numExplicitVisibleGroups=_.get(visibleGroupIds,'length',null);

const isOrgGroupExplicitlyVisible=_.exists(numExplicitVisibleGroups)&&visibleGroupIds.includes(null);

if(isOrgGroupExplicitlyVisible){
this.sidebarVisibilitySettings={
hideOrganizationInSidebar:!1,
organizationGroupName:'Organization'};

return;
}

this.sidebarVisibilitySettings={
hideOrganizationInSidebar:_.exists(numExplicitVisibleGroups)&&numExplicitVisibleGroups===1,
organizationGroupName:_.exists(numExplicitVisibleGroups)&&numExplicitVisibleGroups!==1?'My Groups':'Organization'};

}

get currentlyLoadedGroupIds(){
return this._currentlyLoadedGroupIds;
}

linkController(controller){
controller.groupTreeService=this;

if(_.exists(controller.$state.params.groupId)){
this.selectGroupWithId(controller.$state.params.groupId);
}

controller.$scope.$watch('controller.groupTreeService.selectedGroup',(newlySelectedGroup,oldSelectedGroup)=>{
if(_.exists(newlySelectedGroup)){
controller.$state.go(controller.stateName,{groupId:newlySelectedGroup.id});
controller.dataService.selectGroupDataFor(newlySelectedGroup.id);
}
});
}};


function _getGroupParentMap(groupTree){
const parentMap=new Map;

gt(groupTree).walkTreeFromRoot((node,depth,curPath)=>{
const[parentPath]=strEx(curPath).splitBeforeLast('.children');
const parent=_.get(groupTree,parentPath);
if(_.exists(parent)){
parentMap.set(node,parent);
}
});

return parentMap;
}

function _getParentGroupsOf(group,parentGroupMap){
const parentGroups=[];

if(_.exists(group)){
let lastGroup=group;
while(lastGroup=parentGroupMap.get(lastGroup)){
parentGroups.push(lastGroup);
}
}

return parentGroups;
}

module.exports=GroupTreeService;
//# sourceMappingURL=groupTreeService.js.map
